var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card mb-0" },
    [
      _vm._l(_vm.threadEmails, function (ref, idx) {
        var read = ref.read
        var id = ref.id
        var threadId = ref.threadId
        var messageId = ref.messageId
        var subject = ref.subject
        var fromName = ref.fromName
        var fromEmail = ref.fromEmail
        var ccList = ref.ccList
        var toList = ref.toList
        var opens = ref.opens
        var filesList = ref.filesList
        var openedAt = ref.openedAt
        var createdAt = ref.createdAt
        var sendAt = ref.sendAt
        return _c(
          "div",
          {
            key: id,
            staticClass: "card email-card",
            attrs: {
              "data-read": read,
              "data-email-id": id,
              "data-thread-id": threadId,
              "data-message-id": messageId,
            },
          },
          [
            !_vm.firstItem(idx)
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.left",
                        value: _vm.getEmailThreadTooltipTitle(createdAt),
                        expression: "getEmailThreadTooltipTitle(createdAt)",
                        modifiers: { left: true },
                      },
                    ],
                    staticClass: "email-thread-progress-item",
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-reply",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card-header",
                on: {
                  click: function ($event) {
                    return _vm.handleIframe(id, threadId, messageId, $event)
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "order-2 order-md-1",
                        attrs: { cols: "12", md: "7" },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  subject
                                    ? _c(
                                        _vm.firstItem(idx) ? "h4" : "h6",
                                        {
                                          tag: "div",
                                          staticClass: "bold",
                                          class: _vm.firstItem(idx)
                                            ? "mb-0"
                                            : "",
                                        },
                                        [
                                          _vm.firstItem(idx) &&
                                          !_vm.isCurrentUserInThread
                                            ? _c("icon", {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName: "v-b-tooltip",
                                                    value: _vm.$t(
                                                      "client-profile.messages.yourAreNotInThisThread"
                                                    ),
                                                    expression:
                                                      "\n                      $t('client-profile.messages.yourAreNotInThisThread')\n                    ",
                                                  },
                                                ],
                                                staticClass: "text-danger mr-2",
                                                attrs: {
                                                  name: "exclamation-circle",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(subject) +
                                              "\n                "
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        _vm.firstItem(idx) ? "h4" : "h6",
                                        {
                                          tag: "div",
                                          staticClass:
                                            "font-italic font-weight-light text-light-gray",
                                          class: _vm.firstItem(idx)
                                            ? "mb-0"
                                            : "bold",
                                        },
                                        [
                                          _vm.firstItem(idx) &&
                                          !_vm.isCurrentUserInThread
                                            ? _c("icon", {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName: "v-b-tooltip",
                                                    value: _vm.$t(
                                                      "client-profile.messages.yourAreNotInThisThread"
                                                    ),
                                                    expression:
                                                      "\n                      $t('client-profile.messages.yourAreNotInThisThread')\n                    ",
                                                  },
                                                ],
                                                staticClass: "text-danger mr-2",
                                                attrs: {
                                                  name: "exclamation-circle",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("email.noSubject")
                                              ) +
                                              "\n                "
                                          ),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "bold font-sm text-light-gray mb-1",
                                },
                                [
                                  sendAt
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-danger mr-2 d-flex align-items-center",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("email.delayedUntil")
                                                ) +
                                                ":\n                    " +
                                                _vm._s(
                                                  _vm._f("formatSendAt")(sendAt)
                                                ) +
                                                "\n                  "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ml-2",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "inline-prompt",
                                                {
                                                  attrs: {
                                                    placement: "left",
                                                    "confirmation-text": _vm.$t(
                                                      "client-profile.messages.deleteConfirmation",
                                                      {
                                                        item: _vm.$tc(
                                                          "email.scheduledEmail",
                                                          1
                                                        ),
                                                      }
                                                    ),
                                                  },
                                                  on: {
                                                    accept: function ($event) {
                                                      return _vm.handleCancelScheduledEmail(
                                                        id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-outline-danger clickable",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "email.cancel"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("momentLocal")(
                                          createdAt,
                                          "MMM. DD, YYYY LT"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "bold d-inline-block" },
                                [_vm._v(_vm._s(_vm.$t("email.from")) + ": ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "font-sm text-light-gray bold" },
                                [_vm._v(_vm._s(fromName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "font-sm text-light-gray" },
                                [_vm._v("<" + _vm._s(fromEmail) + ">")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "show-email-cc-wrapper",
                                attrs: { cols: "12" },
                              },
                              [
                                _c("timeline-email-contact-list", {
                                  attrs: {
                                    label: _vm.$t("email.to") + ": ",
                                    "contact-list": toList.list,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "pre-label",
                                        fn: function () {
                                          return [
                                            ccList.list[0]
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "clickable show-email-cc pr-1",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.toggleEmailCC.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa",
                                                      class: _vm.showEmailCC
                                                        ? "fa-caret-up"
                                                        : "fa-caret-down",
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm._v(" "),
                                _vm.showEmailCC
                                  ? _c(
                                      "div",
                                      { staticClass: "show-email-cc-target" },
                                      [
                                        ccList.list[0]
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "timeline-email-contact-list",
                                                  {
                                                    attrs: {
                                                      label:
                                                        _vm.$t("email.cc") +
                                                        ": ",
                                                      "contact-list":
                                                        ccList.list,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "text-right text-gray order-1 order-md-2",
                        attrs: { cols: "12", md: "5" },
                      },
                      [
                        _c(
                          "b-row",
                          { staticClass: "justify-content-end" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "vertical-center",
                                attrs: { cols: "auto" },
                              },
                              [
                                _vm.hasFiles(filesList)
                                  ? _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.top",
                                            value: _vm.checkIfTempEmailId(id)
                                              ? _vm.$t(
                                                  "email.messages.processingEmail"
                                                )
                                              : _vm.$t(
                                                  "email.messages.uploadAttachmentsToDocuments"
                                                ),
                                            expression:
                                              "\n                  checkIfTempEmailId(id)\n                    ? $t('email.messages.processingEmail')\n                    : $t('email.messages.uploadAttachmentsToDocuments')\n                ",
                                            modifiers: { top: true },
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.openUploadFileModal(
                                              filesList,
                                              id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("icon", {
                                          class: {
                                            disabled:
                                              _vm.checkIfTempEmailId(id),
                                          },
                                          attrs: { name: "upload" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("activity-convert-button", {
                                  staticClass: "mr-2",
                                  attrs: { id: id, "activity-type": "email" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.top",
                                        value: _vm.getReplyTooltipText(),
                                        expression: "getReplyTooltipText()",
                                        modifiers: { top: true },
                                      },
                                    ],
                                    staticClass: "reply-email mr-2",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        class: {
                                          disabled: !_vm.isCurrentUserInThread,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.replyEmail(
                                              id,
                                              messageId,
                                              threadId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("icon", {
                                          attrs: { name: "reply" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                ccList.list[0]
                                  ? _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.top",
                                            value: _vm.replyAllTooltipText,
                                            expression: "replyAllTooltipText",
                                            modifiers: { top: true },
                                          },
                                        ],
                                        staticClass: "reply-all-email mr-2",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              disabled:
                                                !_vm.isCurrentUserInThread,
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.replyEmail(
                                                  id,
                                                  messageId,
                                                  threadId,
                                                  "all"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("icon", {
                                              attrs: { name: "reply-all" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.checkIfTempEmailId(id)
                                  ? _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.top",
                                            value: _vm.$t(
                                              "email.messages.processingEmail"
                                            ),
                                            expression:
                                              "$t('email.messages.processingEmail')",
                                            modifiers: { top: true },
                                          },
                                        ],
                                        staticClass: "mr-2 text-danger",
                                      },
                                      [
                                        _c(
                                          "span",
                                          [
                                            _c("icon", {
                                              attrs: {
                                                name: "circle-o-notch",
                                                spin: "",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.firstItem(idx)
                                  ? _c("div", { staticClass: "dropleft" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "grey-text text-darken-4 clickable vertical-center",
                                          attrs: { "data-toggle": "dropdown" },
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("more_vert")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "dropdown-menu" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "inline-prompt",
                                                {
                                                  attrs: {
                                                    placement: "left",
                                                    "confirmation-text": _vm.$t(
                                                      "client-profile.messages.deleteConfirmation",
                                                      {
                                                        item: _vm.$tc(
                                                          "global.words.email",
                                                          1
                                                        ),
                                                      }
                                                    ),
                                                  },
                                                  on: {
                                                    accept: function ($event) {
                                                      return _vm.handleDelete(
                                                        id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "clickable dropdown-item text-danger btn-danger remove-email text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "email.actions.deleteEmail"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-row", { staticClass: "h-75" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 d-flex align-items-end justify-content-end",
                            },
                            [
                              opens > 0
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "mb-0" },
                                        [
                                          _c("icon", {
                                            staticClass:
                                              "ml-2 text-success email-opened-badge",
                                            attrs: { name: "check-circle" },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "font-sm" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    _vm.$tc(
                                                      "global.words.email",
                                                      1
                                                    )
                                                  )
                                                ) + "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-primary bold font-sm",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "email.messages.hasBeenOpened"
                                                  )
                                                ) + ":\n                  "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("i18n", {
                                        staticClass: "mb-0 font-sm",
                                        attrs: {
                                          path: "email.messages.onDate",
                                          tag: "p",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "date",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-primary bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "momentFormat"
                                                            )(
                                                              openedAt,
                                                              "MMM. DD, YYYY LT"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("i18n", {
                                        staticClass: "mb-0 font-sm",
                                        attrs: {
                                          path: "email.messages.andOpenedTimes",
                                          tag: "p",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "times",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-primary bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$tc(
                                                              "email.messages.timesOpened",
                                                              opens,
                                                              { opens: opens }
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card-body p-0 email-preload",
                staticStyle: { height: "0", "overflow-y": "auto" },
                attrs: { id: "email-" + id },
              },
              [
                _vm.hasFiles(filesList)
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "card-footer align-items-center d-flex flex-row flex-wrap",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "bold d-inline-block mr-2 mb-2" },
                          [_vm._v(_vm._s(_vm.$t("email.attachments")) + ":")]
                        ),
                        _vm._v(" "),
                        _vm._l(filesList.files, function (ref) {
                          var filename = ref.filename
                          var documentId = ref.id
                          var size = ref.size
                          return _c(
                            "span",
                            { key: documentId, staticClass: "mb-2" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-primary ml-0 mr-2 mb-0 clickable d-inline-flex flex-row align-items-center",
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadFile(
                                        id,
                                        documentId,
                                        filename,
                                        $event
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-truncate d-inline-block",
                                      staticStyle: { "max-width": "8rem" },
                                      attrs: { title: filename },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(filename) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      " - (" +
                                        _vm._s(_vm._f("humanFileSize")(size)) +
                                        ") "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("icon", {
                                    staticClass: "text-white ml-2",
                                    attrs: { name: "download" },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            ),
          ]
        )
      }),
      _vm._v(" "),
      _c("upload-files-modal", {
        ref: "uploadDocumentsModal",
        attrs: {
          "application-id": _vm.fileUploadInfo.applicationId,
          files: _vm.fileUploadInfo.files,
          "selected-files": _vm.fileUploadInfo.selectedFiles,
          "selected-classification": _vm.fileUploadInfo.selectedClassification,
          uploading: _vm.fileUploadInfo.uploading,
          "uploading-succeeded": _vm.fileUploadInfo.uploadingSucceeded,
          "client-username": _vm.clientUsername,
          applications: _vm.applications,
          "allow-create": "",
          "full-mode": "",
        },
        on: {
          change: _vm.handleChangeUploadInfo,
          reset: _vm.handleResetUploadInfo,
          submit: _vm.handleUploadDocuments,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }